import LazyLoad from 'vanilla-lazyload';
import { initRecaptcha } from '../lib/initRecaptcha';

function init() {
	const lazyCaptchas = [
		'[name="1PDR_EN_CONTACT_FORM"] .g-recaptcha',
		'[name="1PDR_CONTACT_FORM"] .g-recaptcha',
		'[name="1PDR_EN_PARTNERSHIP"] .g-recaptcha',
		'[name="1PDR_PARTNERSHIP"] .g-recaptcha',
	];

	new LazyLoad({
		elements_selector: lazyCaptchas.join(','),
		callback_enter: () => {
			initRecaptcha();
		},
	});
}

init();
